import React from 'react';
import NavBar from '../../components/navbar';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import PaintOrdersForm from '../../components/paint-orders/paintOrdersForm';

const PaintCapacityCreatePage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Capacidad Taller', link: '/paint-capacity' },
    { name: 'Crear Pedido Taller', link: '/paint-capacity-create' }
  ];

  return (
    <div id="main-account" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="account" items={breadcrumbItems} />
      <div className="menu-container">
          <PaintOrdersForm user={props.user} />
      </div>
    </div>
  );
};

export default PaintCapacityCreatePage;